import { LocationCountByLocationType, PlanContainerLocationCount } from "planning-portal-library/src/lib/core/domain/models/plan-container-location-count";
import { PlanContainerLocationCountWebEntity } from "./plan-contianer-location-count-web-entity";
import { Mapper } from "planning-portal-library/src/lib/core/base";
import { LocationCountByLocationTypeWebRepositoryMapper } from "./location-count-web-repository-mapper";
import { LocationCountByLocationTypeWebEntity } from "./location-count-web-entity";

export class PlanContainerLocationCountWebRepositoryMapper extends Mapper<
PlanContainerLocationCountWebEntity,
PlanContainerLocationCount
> {
  constructor() {
    super();
  }

  mapFrom(param: PlanContainerLocationCountWebEntity): PlanContainerLocationCount {
    const locationCountList: LocationCountByLocationType[] = [];
    const locationCountMapper = new LocationCountByLocationTypeWebRepositoryMapper();
    param.locationsCount?.forEach((locationCount) => {
      const mappedLocation = locationCountMapper.mapFrom(locationCount);
      locationCountList.push(mappedLocation);
    });
    return {
      locationsCount: locationCountList,
      totalNoOfLocations: param.totalNoOfLocations
    };
  }

  mapTo(param: PlanContainerLocationCount): PlanContainerLocationCountWebEntity {
    const locationCountWebEntityList: LocationCountByLocationTypeWebEntity[] = [];
    const locationCountMapper = new LocationCountByLocationTypeWebRepositoryMapper();
    param.locationsCount?.forEach((locationCount) => {
      const mappedLocation = locationCountMapper.mapTo(locationCount);
      locationCountWebEntityList.push(mappedLocation);
    });
    return {
      locationsCount:locationCountWebEntityList,
      totalNoOfLocations:param.totalNoOfLocations
    };
  }
}
